import type { Location } from "@/types";

export const LOCATIONS: Record<string, Location> = {
  toronto: { city: "Toronto", tz: "America/Toronto", utc: -4, flag: "\u{1F1E8}\u{1F1E6}", work: [9, 17] },
  vancouver: { city: "Vancouver", tz: "America/Vancouver", utc: -7, flag: "\u{1F1E8}\u{1F1E6}", work: [9, 17] },
  london: { city: "London", tz: "Europe/London", utc: 1, flag: "\u{1F1EC}\u{1F1E7}", work: [9, 17] },
  mumbai: { city: "Mumbai", tz: "Asia/Kolkata", utc: 5.5, flag: "\u{1F1EE}\u{1F1F3}", work: [9, 18] },
  dubai: { city: "Dubai", tz: "Asia/Dubai", utc: 4, flag: "\u{1F1E6}\u{1F1EA}", work: [9, 17] },
  singapore: { city: "Singapore", tz: "Asia/Singapore", utc: 8, flag: "\u{1F1F8}\u{1F1EC}", work: [9, 18] },
};
